import { Phrases } from '@shared/models/locales.model';

export default {
  PreCreateDialog: {
    Title: 'Select Your Customer',
    Desc: 'Please select one of your customers to start creating the shipment for',
    MyCustomer: 'My Customer',
    Template: 'Template',
    Continue: 'Continue',
  },
} as Phrases;
